import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { disclaimer, legalLinks, siteMapLinks, socialLinks } from '../constants';
import { toggleLanguage } from '../utils';
import LinkList from '../LinkList/LinkListComponent';
import SocialLinks from '../SocialLinks/SocialLinksComponent';
import './FooterDesktop.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FooterDesktop = function FooterDesktop(_ref) {
  var language = _ref.language;
  return /*#__PURE__*/_jsxs("div", {
    className: "cgf-main",
    children: [/*#__PURE__*/_jsx("div", {
      className: "cgf-sitemap",
      children: siteMapLinks.map(function (siteMapLink, i) {
        return /*#__PURE__*/_jsx(LinkList, _objectSpread({}, siteMapLink), i);
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "cgf-ending-block",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          className: "cgf-ending-block__disclaimer",
          children: disclaimer
        }), /*#__PURE__*/_jsxs("ul", {
          className: "cgf-ending-block__list",
          children: [legalLinks.links.map(function (_ref2, i) {
            var text = _ref2.text,
              url = _ref2.url;
            return /*#__PURE__*/_jsx("li", {
              className: "cgf-ending-block__listitem",
              children: /*#__PURE__*/_jsx("a", {
                href: url,
                className: "cgf-ending-block__anchor",
                children: text
              })
            }, i);
          }), /*#__PURE__*/_jsx("li", {
            className: "cgf-ending-block__listitem",
            children: /*#__PURE__*/_jsx("a", {
              href: language.href,
              className: "cgf-ending-block__anchor",
              onClick: function onClick() {
                return toggleLanguage(language.abbreviated);
              },
              children: language.original
            }, "cgf-language-toggle-button")
          })]
        })]
      }), /*#__PURE__*/_jsx(SocialLinks, {
        links: socialLinks
      })]
    })]
  });
};
export default FooterDesktop;